import axios from 'axios';

import { toast } from "react-toastify";

export const basePath =
	window.location.origin === 'http://localhost:3000' ? 'http://localhost:8080' : window.location.origin;

export const apiBasePath = `${basePath}/application`;

export async function getTokenRefreshFormValidator() {
  try {
    const resp = await axios.get(`${apiBasePath}/Users/refreshFormValidator`)
    if (resp.data?.error) {
      toast.error(resp.data.error)
    }
  } catch (error) {
    toast.error('Erro ao gerar Token')
    throw error;
  }
}

export async function createNewUserExchangeNotes(_path, _body = null) {
	try {
		const response = await axios.post(`${apiBasePath}${_path}`, _body, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
		return Promise.resolve(response);
	} catch (error) {
    if (error?.response?.message)
      toast.error(error?.response?.message)
    throw error;
	}
}
